import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import Icon from './Icon';
import './CookieBanner.css';

const KEY = 'nexus.cookie.v1';

export default function CookieBanner() {
  const { navigate } = useApp();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) {
        const t = setTimeout(() => setShow(true), 900);
        return () => clearTimeout(t);
      }
    } catch (_) {}
  }, []);

  const save = (consent) => {
    try {
      localStorage.setItem(
        KEY,
        JSON.stringify({ ...consent, savedAt: new Date().toISOString() })
      );
    } catch (_) {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie" role="dialog" aria-label="Cookie 同意">
      <div className="cookie__inner">
        <div className="cookie__icon" aria-hidden>
          <Icon name="shield" size={20} />
        </div>
        <div className="cookie__body">
          <strong>我們使用 Cookie 改善您的體驗</strong>
          <p>
            QQCARD 使用必要、統計與行銷 Cookie 提供更好的服務。您可選擇接受所有 Cookie，僅接受必要 Cookie，或
            <button
              type="button"
              className="cookie__link"
              onClick={() => navigate('info', { topic: 'cookie' })}
            >
              閱讀 Cookie 政策
            </button>
            。
          </p>
        </div>
        <div className="cookie__actions">
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            onClick={() => save({ necessary: true, stats: false, marketing: false })}
          >
            僅必要
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={() => save({ necessary: true, stats: true, marketing: true })}
          >
            接受全部
          </button>
        </div>
      </div>
    </div>
  );
}
